import { useCallback, useState } from 'react';
export function useScrollPercentage(ref, numberOfElements) {
  const [scrollPercentage, setScrollPercentage] = useState(0);
  const [currentElement, setCurrentElement] = useState(0);
  const onScroll = useCallback(e => {
    const percentage = e.currentTarget.scrollLeft / (e.currentTarget.scrollWidth - e.currentTarget.clientWidth);
    setScrollPercentage(percentage);
    setCurrentElement(Math.floor((numberOfElements - 1) * percentage));
  }, [numberOfElements]);
  const prev = useCallback(() => {
    if (ref.current) {
      ref.current.scrollTo(ref.current.scrollLeft - ref.current.clientWidth, 0);
    }
  }, [ref]);
  const next = useCallback(() => {
    if (ref.current) {
      ref.current.scrollTo(ref.current.scrollLeft + ref.current.clientWidth, 0);
    }
  }, [ref]);
  return {
    onScroll,
    next,
    prev,
    scrollPercentage,
    currentElement
  };
}
export default useScrollPercentage;
//# sourceMappingURL=useScrollPercentage.js.map